import constant from "../../../../../constants/constant";
import { getUniqueObj } from "../../../../../constants/utils";
import {
    HandleCalculationProps,
    HandleSearchSelectProps,
    product_details,
    ProductData,
    TAdditionalKeys,
    TSearchProduct,
} from "../interface";

export const useCalculation = () => {
    // To calculate the total srp of product
    const calcTotalSrp = (response: product_details[] | null): number => {
        if (!response) return 0;
        return response.reduce((acc, item) => {
            const srp = item.product.product_srp ?? 0;
            const qty = item.quantity ?? 1;
            return acc + srp * qty;
        }, 0);
    };

    //Function to modified data to perform calculation of inventory table
    const transformSearchProduct = (
        response: TSearchProduct,
        regionCode: number,
        gstType:number
    ): ProductData => {
        let isKuwaitRegion: boolean = regionCode === constant.STORE_REGION.KUWAIT;
        const qty = 1;
        const total_price = 0;
        const gstRate = isKuwaitRegion
            ? response.product_type?.tax_rate ?? 0
            : response.product_type?.gst_percentage ?? 0;
        const srp = response.product_srp ?? 0;

        const gst_amount = (total_price * gstRate) / 100;
        const srp_amount = srp * qty;
        const cost_amount = parseFloat(
            (
                srp *
                0.01 *
                getUniqueObj(
                    response.brand.product_types,
                    "product_type_id",
                    response.product_type_id
                )?.specx_landing_cost
            )?.toFixed(2)
        );

        const additionalKeys: TAdditionalKeys = {
            cost_amount: cost_amount,
            discount_amount: 0,
            discount_percentage: 0,
            qty: 1,
            subtotal_amount: cost_amount,
            gst_amount: (cost_amount * gstRate) / 100,
            grand_total_amount:
                cost_amount + ((cost_amount * gstRate) / 100),
        };

        return {
            ...response,
            sum_qty: qty,
            sum_total_price: total_price,
            cost_amount,
            qty,
            total_price,
            gst_amount,
            srp_amount,
            custom_index: 0,
            additional_keys: additionalKeys,
        };
    };

    //Function to select the search product
    const handleSearchSelect = ({
        response,
        prevData,
        setProductData,
        regionCode,
        gstType
    }: HandleSearchSelectProps) => {
        const tempData = transformSearchProduct(response, regionCode,gstType);

        const alreadyExists = prevData.some((item) => item?.id === tempData?.id);

        // Prevent duplicate and index shift
        if (alreadyExists) return;

        // Append to preserve order
        setProductData([tempData, ...prevData]);
    };

    //Function to handleCalculation
    const handleCalculation = ({
        productData,
        setProductData,
        type,
        id,
        value,
        getGSTByRegion
    }: HandleCalculationProps) => {
        const tempData = [...productData];

        //find the index
        const index: number = tempData?.findIndex((item) => item.id === id);

        tempData[index].additional_keys = {
            ...tempData[index].additional_keys,
            [type]: value,
        };

        const isCostAmountChange:boolean = type === 'cost_amount'
        const item = tempData[index];
        const gstRate = getGSTByRegion(item?.product_type);
        const qty = Number(item?.additional_keys?.qty);
        const cost_amount = Number(item?.additional_keys?.cost_amount);
        let discount_amount = isCostAmountChange ? 0 : item?.additional_keys?.discount_amount;
        let discount_percentage = isCostAmountChange ? 0 : item?.additional_keys?.discount_percentage;

        // Update the changed field
        if (type === "discount_amount") {
            discount_percentage = cost_amount && !isCostAmountChange
                ? (discount_amount / cost_amount) * 100
                : 0;
        } else if (type === "discount_percentage") {
            discount_amount = cost_amount && !isCostAmountChange
                ? (discount_percentage / 100) * cost_amount
                : 0;
        }

        let subTotalAmount =  (cost_amount - discount_amount) * qty
        let gst_amount = (subTotalAmount * gstRate) / 100;

        const additionalKeys: TAdditionalKeys = {
            cost_amount:item?.additional_keys?.cost_amount ? cost_amount : NaN,
            discount_amount: discount_amount,
            discount_percentage: discount_percentage,
            qty: item?.additional_keys?.qty ? qty : NaN,
            subtotal_amount: subTotalAmount,
            gst_amount: gst_amount,
            grand_total_amount:subTotalAmount + gst_amount,
        };
        tempData[index].additional_keys = additionalKeys;
        setProductData(tempData);
    };

    return {
        calcTotalSrp,
        transformSearchProduct,
        handleSearchSelect,
        handleCalculation,
    };
};
